import SvgIcon from "@mui/material/SvgIcon";

export default function TikTokIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M12.75 2c.42 3.36 2.67 5.09 5.75 5.25v3.3a8.7 8.7 0 0 1-5.1-1.8v7.68a6.45 6.45 0 1 1-6.45-6.45c.45 0 .9.06 1.32.15v3.36a3.15 3.15 0 1 0 2.16 3v-14.5h2.32z" />
    </SvgIcon>
  );
}
